import React from 'react';

const Gradient = () => {
  return (
    <div className="gradient"></div>
  )
}

export default Gradient;